export default __webpack_public_path__ + "static/media/wallet.22635a31.png";